import { useState } from 'react';
import { isMobile } from 'react-device-detect';

const TabReport = ({ values, checklist = [] }) => {
  const [currentTab, setCurrentTab] = useState(1); // 1: Imagens, 2: Checklist
  const checklistData = checklist;

  const tabChecklists = {
    IMAGE_REGISTER: 1,
    FIXED_CHECKLIST: 2,
  };

  // Parse do JSON se necessário
  const entryChecklist =
    typeof values?.entry_checklist === 'string'
      ? JSON.parse(values.entry_checklist || '{}')
      : values?.entry_checklist || {};

  const imageRegister = Array.isArray(entryChecklist?.image_register)
    ? entryChecklist.image_register
    : [];
  const fixedChecklist = entryChecklist?.fixed_checklist || {};

  return (
    <div style={{ marginTop: 20 }}>
      {/* Tabs */}
      <div
        style={{
          display: 'flex',
          gap: '10px',
          marginBottom: '20px',
          flexWrap: 'wrap',
        }}
      >
        <button
          onClick={() => setCurrentTab(tabChecklists.IMAGE_REGISTER)}
          style={{
            padding: '10px 20px',
            backgroundColor:
              currentTab === tabChecklists.IMAGE_REGISTER ? '#62C300' : '#333',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '500',
          }}
        >
          Registro por imagem
        </button>
        <button
          onClick={() => setCurrentTab(tabChecklists.FIXED_CHECKLIST)}
          style={{
            padding: '10px 20px',
            backgroundColor:
              currentTab === tabChecklists.FIXED_CHECKLIST ? '#62C300' : '#333',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '500',
          }}
        >
          Checklist
        </button>
      </div>

      {/* Tab Content */}
      {currentTab === tabChecklists.IMAGE_REGISTER && (
        <div>
          <h5
            style={{
              color: 'white',
              fontFamily: 'Poppins, sans-serif',
              marginBottom: '15px',
            }}
          >
            Registro por imagem
          </h5>
          {imageRegister.length === 0 ? (
            <div
              style={{ color: 'gray', textAlign: 'center', padding: '20px' }}
            >
              Nenhuma imagem cadastrada
            </div>
          ) : (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isMobile
                  ? 'repeat(1, 1fr)'
                  : 'repeat(3, 1fr)',
                gap: '15px',
              }}
            >
              {imageRegister.map((imageItem, index) => (
                <div
                  key={imageItem.id || index}
                  style={{
                    border: '1px solid #333',
                    padding: '10px',
                    backgroundColor: '#2a2a2a',
                    borderRadius: '4px',
                  }}
                >
                  {imageItem.image && (
                    <img
                      src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${imageItem.image}`}
                      alt={`Registro ${index + 1}`}
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'cover',
                        border: '1px solid #444',
                        marginBottom: '10px',
                        borderRadius: '4px',
                      }}
                    />
                  )}
                  <div style={{ fontSize: '13px', color: 'white' }}>
                    {imageItem.piece && (
                      <div style={{ marginBottom: '5px' }}>
                        <strong>Peça:</strong>{' '}
                        {typeof imageItem.piece === 'object'
                          ? imageItem.piece.label
                          : imageItem.piece}
                      </div>
                    )}
                    {imageItem.description && (
                      <div style={{ marginBottom: '5px' }}>
                        <strong>Descrição:</strong>{' '}
                        {typeof imageItem.description === 'object'
                          ? imageItem.description.label
                          : imageItem.description}
                      </div>
                    )}
                    {imageItem.observation && (
                      <div style={{ marginBottom: '5px' }}>
                        <strong>Observação:</strong> {imageItem.observation}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {currentTab === tabChecklists.FIXED_CHECKLIST && (
        <div>
          <h5
            style={{
              color: 'white',
              fontFamily: 'Poppins, sans-serif',
              marginBottom: '15px',
            }}
          >
            Checklist
          </h5>
          {checklistData.length === 0 ? (
            <div
              style={{ color: 'gray', textAlign: 'center', padding: '20px' }}
            >
              Nenhum checklist cadastrado
            </div>
          ) : (() => {
            // Filtra itens com status diferente de 1 (não marcado)
            const filteredItems = checklistData.filter((item) => {
              const itemValues = fixedChecklist[item.name];
              const status = itemValues?.status || 1;
              return status !== 1;
            });

            // Se não há itens marcados, exibe mensagem
            if (filteredItems.length === 0) {
              return (
                <div
                  style={{ color: 'gray', textAlign: 'center', padding: '20px' }}
                >
                  Nenhum item marcado no checklist
                </div>
              );
            }

            return (
              <div
                style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
              >
                {filteredItems.map((item) => {
                const itemValues = fixedChecklist[item.name];
                const status = itemValues?.status || 1;

                // Status: 1 = não marcado, 2 = ok (verde), 3 = atenção (vermelho)
                let statusIcon = '⬜';
                let statusColor = '#999';

                if (status === 2) {
                  statusIcon = '✓';
                  statusColor = '#52F035';
                } else if (status === 3) {
                  statusIcon = '⚠';
                  statusColor = '#F24726';
                }

                return (
                  <div
                    key={item.id}
                    style={{
                      border: '1px solid #333',
                      borderRadius: '6px',
                      padding: '10px',
                      backgroundColor: '#2a2a2a',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        marginBottom: itemValues?.image ? '10px' : '0',
                      }}
                    >
                      <span style={{ fontSize: '20px', color: statusColor }}>
                        {statusIcon}
                      </span>
                      <label
                        style={{
                          color: 'white',
                          fontFamily: 'Poppins, sans-serif',
                          fontSize: '14px',
                        }}
                      >
                        {item.name}
                      </label>
                    </div>

                    {/* Se tiver imagem e detalhes */}
                    {itemValues?.image && (
                      <div
                        style={{
                          display: 'flex',
                          gap: '10px',
                          marginTop: '10px',
                          flexWrap: 'wrap',
                        }}
                      >
                        <img
                          src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${itemValues.image}`}
                          alt={item.name}
                          style={{
                            width: '120px',
                            height: '120px',
                            objectFit: 'cover',
                            border: '1px solid #444',
                            borderRadius: '4px',
                          }}
                        />
                        <div
                          style={{
                            flex: 1,
                            fontSize: '13px',
                            color: 'white',
                            minWidth: '200px',
                          }}
                        >
                          {itemValues?.piece && (
                            <div style={{ marginBottom: '5px' }}>
                              <strong style={{ color: 'gray' }}>Peça: </strong>
                              {typeof itemValues.piece === 'object'
                                ? itemValues.piece.label
                                : itemValues.piece}
                            </div>
                          )}
                          {itemValues?.description && (
                            <div style={{ marginBottom: '5px' }}>
                              <strong style={{ color: 'gray' }}>
                                Descrição:{' '}
                              </strong>
                              {typeof itemValues.description === 'object'
                                ? itemValues.description.label
                                : itemValues.description}
                            </div>
                          )}
                          {itemValues?.observation && (
                            <div style={{ marginBottom: '5px' }}>
                              <strong style={{ color: 'gray' }}>
                                Observações:{' '}
                              </strong>
                              {itemValues.observation}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            );
          })()}
        </div>
      )}

    </div>
  );
};

export default TabReport;
